import React from 'react';
import NavigationStepper, {
	NavigationStepperComponentParams,
	NavigationStepperItemType,
} from '../../../../../Components/Stepper/NavigationStepper';
import SubTabNavigationStepperItems from '../../../../../Components/Stepper/SubTabNavigationStepper/SubTabNavigationStepperItems';
import ManagerCalendarNotifications from './ManagerCalendarNotifications/ManagerCalendarNotifications';
import ManagerCalendarViewSettings from './ManagerCalendarViewSettings/ManagerCalendarViewSettings';
import AbsenceCalendar from '../../../../../Components/Calendar/AbsenceCalendar';
import { useManagerContext } from '../../../Services/ManagerContext';
import WorkplaceOrderingSettingsCalendar from '../../../../../Components/Calendar/WorkplaceOrderingSettingsCalendar';
import { ServiceScheduleContextProvider } from '../../../../WorkplaceMember/Services/ServiceScheduleContext';
import ServiceScheduleCalendar from '../../../../Calendar/Components/ServiceScheduleCalendar/ServiceScheduleCalendar';
import { ServiceScheduleType } from '../../../../../graphql/graphql';
import ManagerCalendarWorkingHours from './ManagerCalendarWorkingHours/ManagerCalendarWorkingHours';

const ManagerCalendarWrapper: React.FC = () => {
	const { workplaceId } = useManagerContext();

	const steps: NavigationStepperItemType[] = [
		{
			name: 'component.managerCalendarWrapper.shifts',
			key: 'shifts',
			component: (params: NavigationStepperComponentParams) => (
				<>
					<ServiceScheduleContextProvider workplaceId={workplaceId}>
						<ServiceScheduleCalendar
							scheduleTypes={[
								ServiceScheduleType.Shift,
								ServiceScheduleType.ShiftExtra,
							]}
							workplaceId={workplaceId}
						/>
					</ServiceScheduleContextProvider>
				</>
			),
		},
		{
			name: 'component.managerCalendarWrapper.onlineOrdering',
			key: 'onlineOrdering',
			component: (params: NavigationStepperComponentParams) => (
				<WorkplaceOrderingSettingsCalendar workplaceId={workplaceId} />
			),
		},
		{
			name: 'component.managerCalendarWrapper.absence',
			key: 'absence',
			component: (params: NavigationStepperComponentParams) => (
				<AbsenceCalendar />
			),
		},
		{
			name: 'component.managerCalendarWrapper.workplaceCalendarSettings',
			key: 'workplaceCalendarSettings',
			component: (params: NavigationStepperComponentParams) => (
				<ManagerCalendarViewSettings />
			),
		},
		{
			name: 'component.managerCalendarWrapper.notifications',
			key: 'notifications',
			component: (params: NavigationStepperComponentParams) => (
				<ManagerCalendarNotifications />
			),
		},
		{
			name: 'component.managerCalendarWrapper.workingHours',
			key: 'workingHours',
			component: (params: NavigationStepperComponentParams) => (
				<ManagerCalendarWorkingHours />
			),
		},
	];

	return (
		<NavigationStepper
			steps={steps}
			initialStepPath='shifts'
			canSkip
			renderItems={({ items, activeKey, onChange }) => (
				<SubTabNavigationStepperItems
					items={items}
					activeKey={activeKey}
					onChange={onChange}
				/>
			)}
		/>
	);
};

export default ManagerCalendarWrapper;
